import { render, staticRenderFns } from "./ChatOption.vue?vue&type=template&id=9bc240fa&scoped=true&"
import script from "./ChatOption.vue?vue&type=script&lang=js&"
export * from "./ChatOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc240fa",
  null
  
)

export default component.exports